// DrilldownPopup.js
import React, { useEffect, useState } from "react";
import { Button, Box, CircularProgress, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { checkdrilldown, getlistofcolumnformappingfirst, getlistofcolumnformappingsecond, getreporttitlefromondashbaord, saveMapDataForDrillDown, setDrilldownTypeCheckdashboard, } from "../../actions/reportmanagement";
import { decryptData } from "../utils/EncriptionStore";
import { toast } from "react-toastify";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import './defaultcreatedrilldown.css';
import { Modal } from "react-bootstrap";

const DrilldownPopup = ({ open, onClose }) => {
    const [selectColumnForDrill, setSelectColumnForDrill] = useState({ Master_Column: [], DrillDown_Column: [] });
    const [columnCount, setcolumnCount] = useState();
    const [drilldownmessage, setDrillDownMessage] = useState("");
    const [selectReportTitleDrilldown, setSelectReportTitleDrilldown] = useState();
    const [selectedColumn, setSelectedColumn] = useState(null);
    const [loader, setLoader] = useState(false);
    const [normalCustomQueryInputWidth, setNormalCustomQueryInputWidth] = useState(0);
    const [tagBtnClciked, setTagBtnClciked] = useState(false);
    const dispatch = useDispatch();
    const apiData = useSelector((state) => state);

    const user = (() => {
        const encryptedData = localStorage.getItem("profile");
        return encryptedData ? decryptData(encryptedData) : null;
    })();

    const CustomeDetailOfReport = JSON.parse(
        localStorage.getItem("customeDetailOfReport")
    );

    const selectedShemasection = JSON.parse(
        localStorage.getItem("SelectedSchema")
    );

    useEffect(() => {
        const fetchData = async () => {
            try {
                setSelectColumnForDrill({ Master_Column: [], DrillDown_Column: [] });
                setLoader(true);
                await dispatch(
                    checkdrilldown({
                        query: CustomeDetailOfReport?.query,
                        type: CustomeDetailOfReport?.type,
                        db_type: selectedShemasection?.databasename,
                        schema_name: selectedShemasection?.selectedSchema,
                        customer_id: user?.customer_id,
                        database_type: user?.database_type,
                    })
                );

                await dispatch(
                    getreporttitlefromondashbaord({
                        database_type: user.database_type,
                        email: user.user_email_id,
                        customer_id: user.customer_id,
                        group_id: user.group_id,
                    })
                );
            } catch (error) {
                console.log("Facing Issue to fetch the Column", error);
            } finally {
                setLoader(false);
            }
        };

        fetchData();
    }, []);


    const reportdetail = apiData?.reportmanagement?.allReportDetail;
    const reportdetailForMapping = reportdetail?.length
        ? reportdetail
            .filter((item) =>
                CustomeDetailOfReport?.chart_type !== 'drillcolumn'
                    ? item.report_type === "Table"
                    : item.report_type === "Chart"
            )
            .map((report) => ({
                value: report.report_name,
                label: report.report_name,
            }))
        : [];

    const checkquerysupportdrilldown = apiData?.reportmanagement?.checkdrilldown;
    const columndetailfirst = apiData?.reportmanagement?.getlistofcolumfirst;
    const columndetailsecond = apiData?.reportmanagement?.getlistofcolumsecond;
    const savemapdatadrilldown = apiData?.reportmanagement?.savemapdatafordrilldown;

    const getDrillDownColumns = (index) => {
        const currentDrillDownColumn = selectColumnForDrill[index]?.DrillDown_Column;
        const drillDownColumn = Array.isArray(currentDrillDownColumn) && currentDrillDownColumn.length > 0
            ? currentDrillDownColumn
            : [];
        return Array.isArray(drillDownColumn)
            ? drillDownColumn.map(value => ({ value, label: value }))
            : [];
    };

    useEffect(() => {
        if (savemapdatadrilldown?.StatusCode === 200) {
            dispatch(setDrilldownTypeCheckdashboard(true))
            const CustomeDetailOfReport = JSON.parse(
                localStorage.getItem("customeDetailOfReport")
            );

            if (CustomeDetailOfReport) {
                CustomeDetailOfReport.drilldown_type = "default"; // set default value
                localStorage.setItem(
                    "customeDetailOfReport",
                    JSON.stringify(CustomeDetailOfReport)
                );
            }
            onClose();
        }
    }, [savemapdatadrilldown]);


    useEffect(() => {
        if (checkquerysupportdrilldown !== "null") {
            if (checkquerysupportdrilldown?.drilldown === "yes") {
                setcolumnCount(checkquerysupportdrilldown?.column_mapping);
                setSelectColumnForDrill(
                    Array.from(
                        { length: checkquerysupportdrilldown?.column_mapping },
                        () => ({
                            Master_Column: [],
                            DrillDown_Column: [],
                        })
                    )
                );
            }
        }
    }, [checkquerysupportdrilldown]);

    const handleSelectReportNamedropfirst = async (e) => {
        e.preventDefault();
        setTagBtnClciked(!tagBtnClciked);

        if (selectReportTitleDrilldown != "") {
            dispatch(
                getlistofcolumnformappingfirst({
                    customer_id: user?.customer_id,
                    connection_type: selectedShemasection?.databasename,
                    schema: selectedShemasection?.selectedSchema,
                    for_master_report: "yes",
                    query: CustomeDetailOfReport.query,
                    database_type: user.database_type,
                })
            );
            dispatch(
                getlistofcolumnformappingsecond({
                    customer_id: user?.customer_id,
                    connection_type: selectedShemasection?.databasename,
                    schema: selectedShemasection?.selectedSchema,
                    for_master_report: "no",
                    report_title: selectReportTitleDrilldown,
                    database_type: user.database_type,
                })
            );
        } else {
            toast.success("Please provide Report Title", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light", });
            setDrillDownMessage("Please provide Report Title");
        }
    };

    const handleSelectReportforlist = (selectedOption) => {
        setSelectReportTitleDrilldown(selectedOption ? selectedOption.value : "");
        setDrillDownMessage("");
    };

    const customStylesForSelect = {
        menu: (provided) => ({
            ...provided,
            zIndex: 9999, // Ensure this is above other elements
            position: "absolute", // Explicitly set the position
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 9999, // Ensure the portal has a high z-index
        }),
    };

    const handleSelectColumnForDrillDownSecond = (index) => (selectedOptions) => {
        // Ensure selectedOptions is an array
        const selectedValues = Array.isArray(selectedOptions)
            ? selectedOptions.map(option => option.value)
            : selectedOptions ? [selectedOptions.value] : [];

        setSelectColumnForDrill((prevState) => {
            const updatedColumns = [...prevState];
            if (!updatedColumns[index]) {
                updatedColumns[index] = { DrillDown_Column: [] };
            }
            updatedColumns[index].DrillDown_Column = selectedValues;
            return updatedColumns;
        });
    };

    const handleSelectMap = async (e) => {
        e.preventDefault();
        if (!tagBtnClciked && CustomeDetailOfReport.enable_drilldown == 'yes') {
            toast.warn("Please click on the tag button to select the column", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light", });
            return; // Exit function if the condition is not met
        }
        const payloadvalue = {
            Master_Column: Array.from(
                { length: columnCount },
                (v, i) => columndetailfirst && columndetailfirst[i]
            ),
            // DrillDown_Column: selectColumnForDrill?.map((item) => item.DrillDown_Column[0]) || [],
            DrillDown_Column: Array.isArray(selectColumnForDrill)
                ? selectColumnForDrill.map((item) =>
                    Array.isArray(item.DrillDown_Column) ? item.DrillDown_Column[0] || "" : item.DrillDown_Column || ""
                )
                : [],
        };
        const newobject = {
            ...payloadvalue,
            customer_id: user.customer_id,
            drilldown_report: selectReportTitleDrilldown,
            master_report: CustomeDetailOfReport.title,
            database_type: user.database_type,
            Date_Column: selectedColumn?.value ? [selectedColumn?.value] : [],
            type: "save"
        };
        if (CustomeDetailOfReport.type != "Box") {
            dispatch(saveMapDataForDrillDown(newobject));
        } else {
            const payloadvaluedata = {
                Master_Column: [],
                DrillDown_Column: [],
            };
            const newobject2 = {
                ...payloadvaluedata,
                customer_id: user.customer_id,
                drilldown_report: selectReportTitleDrilldown,
                master_report: CustomeDetailOfReport.title,
                Date_Column: selectedColumn?.value ? [selectedColumn?.value] : [],
                type: "save"
            };
            dispatch(saveMapDataForDrillDown(newobject2));
        }
    };

    useEffect(() => {
        const normalCustomQueryInputDiv = document.getElementById(
            "normalCustomQueryInputId"
        );
        if (normalCustomQueryInputDiv) {
            const resizeObserver = new ResizeObserver(() => {
                const rect = normalCustomQueryInputDiv.getBoundingClientRect();
                setNormalCustomQueryInputWidth(rect.width);
            });
            resizeObserver.observe(normalCustomQueryInputDiv);
            return () => {
                resizeObserver.unobserve(normalCustomQueryInputDiv);
                resizeObserver.disconnect();
            };
        }
    }, []);

    return (
        <Modal show={open} onHide={onClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title className="drilldown-modal-title" >Map Drill Down Report</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loader ? (
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "300px" }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <div
                        style={{ minWidth: normalCustomQueryInputWidth }}
                        className="drilldown-custome-mapping-container"
                    >
                        <div className="drilldownquery-sub-cnt">
                            {drilldownmessage != null ? (
                                <p>{drilldownmessage}</p>
                            ) : null}
                            <div className="drilldownquery-well form-horizon">
                                <div className="drilldown-custome-container-column">
                                    <Form.Group
                                        controlId="formBasicEmail"
                                    >
                                        <Form.Control
                                            type="text"
                                            value={CustomeDetailOfReport.title}
                                            disabled
                                            required
                                            placeholder="Report Name"
                                            style={{
                                                background: "#f5f6fa",
                                                border: "1px solid #d1d5db",
                                                borderRadius: 8,
                                                color: "#222",
                                                fontWeight: 500,
                                                fontSize: 15,
                                                padding: "10px 14px",
                                                boxShadow: "none",
                                                opacity: 1,
                                                cursor: "not-allowed"
                                            }}
                                        />
                                    </Form.Group>
                                    <div className="drilldown-reportMappinAndTaggingDiv">
                                        <Select
                                            className="drilldown-ReportNameForMapping drilldown-columnSelectCustomQuery"
                                            value={reportdetailForMapping.find(
                                                (option) =>
                                                    option.value === selectReportTitleDrilldown
                                            )}
                                            onChange={handleSelectReportforlist}
                                            options={reportdetailForMapping}
                                            isSearchable
                                            placeholder="Select report name"
                                            styles={{
                                                ...customStylesForSelect,
                                                control: (provided, state) => ({
                                                    ...provided,
                                                    minHeight: 44,
                                                    borderRadius: 8,
                                                    borderColor: state.isFocused ? "#4bb9da" : "#d1d5db",
                                                    boxShadow: state.isFocused ? "0 0 0 2px #e3f6fc" : "none",
                                                    background: "#f5f6fa",
                                                    fontSize: 15,
                                                    fontWeight: 500,
                                                    color: "#222",
                                                    paddingLeft: 2,
                                                    transition: "border-color 0.2s",
                                                    width: 320, // <-- Set your desired width here (in px)
                                                    maxWidth: "100%",
                                                }),
                                                // ...other style overrides...
                                            }}
                                            menuPortalTarget={document.body} // Render menu in a portal
                                            menuPosition="fixed"
                                            onMouseDown={e => e.stopPropagation()} // <-- Add this line
                                        />

                                        <div className="drilldown-reportTaggingButton">
                                            <Button
                                                className="drilldown-primary-btn"
                                                style={{ margin: "5px" }}
                                                onClick={handleSelectReportNamedropfirst}
                                            >
                                                Tag
                                            </Button>
                                        </div>
                                    </div>
                                </div>

                                {CustomeDetailOfReport.type != "Box" &&
                                    Array.from({ length: columnCount }, (v, i) => (
                                        <div className="drilldown-custome-container-column" key={i}>
                                            <Form.Group
                                                controlId="formBasicEmail"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    value={
                                                        columndetailfirst && columndetailfirst[i]
                                                    }
                                                    disabled
                                                    required
                                                    placeholder="Select Master Column"
                                                    style={{
                                                        background: "#f5f6fa",
                                                        border: "1px solid #d1d5db",
                                                        borderRadius: 8,
                                                        color: "#222",
                                                        fontWeight: 500,
                                                        fontSize: 15,
                                                        padding: "10px 14px",
                                                        boxShadow: "none",
                                                        opacity: 1,
                                                        cursor: "not-allowed"
                                                    }}
                                                />
                                            </Form.Group>
                                            <div
                                                style={{
                                                    flex: 1,
                                                    float: "right",
                                                    maxWidth: "72% !important",
                                                }}
                                            >
                                                <Select
                                                    className="drilldown-adjustment-style"
                                                    value={getDrillDownColumns(i)}
                                                    onChange={handleSelectColumnForDrillDownSecond(i)}
                                                    options={columndetailsecond?.map(column => ({ value: column, label: column })) || []}
                                                    isSearchable
                                                    placeholder="Select DrillDown Column"
                                                    styles={{
                                                        ...customStylesForSelect,
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            minHeight: 44,
                                                            borderRadius: 8,
                                                            borderColor: state.isFocused ? "#4bb9da" : "#d1d5db",
                                                            boxShadow: state.isFocused ? "0 0 0 2px #e3f6fc" : "none",
                                                            background: "#f5f6fa",
                                                            fontSize: 15,
                                                            fontWeight: 500,
                                                            color: "#222",
                                                            paddingLeft: 2,
                                                            transition: "border-color 0.2s",
                                                            width: 320, // <-- Set your desired width here (in px)
                                                            maxWidth: "100%",
                                                        }),
                                                        // ...other style overrides...
                                                    }}
                                                    menuPortalTarget={document.body}
                                                    menuPosition="fixed"
                                                />
                                            </div>
                                        </div>
                                    ))}
                                {CustomeDetailOfReport.enable_range_filter === "yes" && (
                                    <div className="drilldown-custome-container-column">
                                        <Form.Group
                                            controlId="formBasicEmail"
                                        >
                                            <Form.Control
                                                type="text"
                                                value={"Duration"}
                                                disabled
                                                required
                                                placeholder="Report Name"
                                                style={{
                                                    background: "#f5f6fa",
                                                    border: "1px solid #d1d5db",
                                                    borderRadius: 8,
                                                    color: "#222",
                                                    fontWeight: 500,
                                                    fontSize: 15,
                                                    padding: "10px 14px",
                                                    boxShadow: "none",
                                                    opacity: 1,
                                                    cursor: "not-allowed"
                                                }}
                                            />
                                        </Form.Group>
                                        <div className="drilldown-reportMappinAndTaggingDiv">
                                            <Select
                                                className="drilldown-ReportNameForMapping drilldown-columnSelectCustomQuery"
                                                value={selectedColumn}
                                                onChange={(option) => setSelectedColumn(option)}
                                                options={
                                                    columndetailsecond?.map((column) => ({
                                                        value: column,
                                                        label: column,
                                                    })) || []
                                                }
                                                isSearchable
                                                placeholder="Select report name"
                                                styles={{
                                                    ...customStylesForSelect,
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        minHeight: 44,
                                                        borderRadius: 8,
                                                        borderColor: state.isFocused ? "#4bb9da" : "#d1d5db",
                                                        boxShadow: state.isFocused ? "0 0 0 2px #e3f6fc" : "none",
                                                        background: "#f5f6fa",
                                                        fontSize: 15,
                                                        fontWeight: 500,
                                                        color: "#222",
                                                        paddingLeft: 2,
                                                        transition: "border-color 0.2s",
                                                        width: 320, // <-- Set your desired width here (in px)
                                                        maxWidth: "100%",
                                                    }),
                                                    // ...other style overrides...
                                                }}
                                                menuPortalTarget={document.body} // Render menu in a portal
                                                menuPosition="fixed"
                                                onMouseDown={e => e.stopPropagation()} // <-- Add this line
                                            />

                                            <div className="drilldown-reportTaggingButton">
                                                <Button
                                                    className="drilldown-primary-btn"
                                                    style={{ margin: "5px" }}
                                                    onClick={handleSelectMap}
                                                >
                                                    Map
                                                </Button>
                                            </div>
                                        </div>
                                    </div>)}
                                {CustomeDetailOfReport.enable_range_filter === "no" && (
                                    <div>
                                        <Button
                                            className="drilldown-primary-btn"
                                            style={{ margin: "5px" }}
                                            onClick={handleSelectMap}
                                        >
                                            Map
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                )}
            </Modal.Body>
            <Modal.Footer>
                <Button className="drilldown-primary-btn" onClick={onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DrilldownPopup;
